import { render } from "./PrivacityPage.vue?vue&type=template&id=af1c4080"
import script from "./PrivacityPage.vue?vue&type=script&lang=js"
export * from "./PrivacityPage.vue?vue&type=script&lang=js"
script.render = render

export default script